<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 438 427"
  >
    <path
      :fill="iconColor"
      d="M409.1 114.6A218.3 218.3 0 00219.3 5.4 218.3 218.3 0 000 224.7c0 47.7 14 90.7 41.8 128.8 28 38.2 64 64.6 108 79.3 5.2 1 9 .2 11.5-2 2.5-2.3 3.7-5.2 3.7-8.6a6589.9 6589.9 0 00-.3-40.8l-6.5 1.1a120.7 120.7 0 01-35.7-1c-6.9-1.2-13.3-4-19.2-8.5a36.2 36.2 0 01-12.5-17.6l-2.9-6.6a71.3 71.3 0 00-9-14.5c-4-5.4-8.2-9-12.4-10.9l-2-1.4a21 21 0 01-6.3-7.4c-.5-1.4 0-2.5 1.5-3.3 1.5-.9 4.3-1.3 8.2-1.3l5.8.9c3.8.7 8.5 3 14 6.8a46 46 0 0114 14.9 50.3 50.3 0 0015.8 17.8c6.2 4 12.4 6.1 18.7 6.1 6.3 0 11.7-.4 16.3-1.4 4.5-1 8.8-2.4 12.8-4.3a46.3 46.3 0 0114-29.4 195.5 195.5 0 01-29.3-5.1c-8.6-2.3-17.6-6-26.8-11.2a76.9 76.9 0 01-23-19 92 92 0 01-15-30 142.6 142.6 0 01-5.8-42.9c0-23 7.5-42.6 22.5-58.8-7-17.3-6.4-36.7 2-58.3 5.5-1.7 13.7-.4 24.6 3.9a171.7 171.7 0 0136 18.7 203 203 0 01109.6 0l10.8-6.8c7.5-4.6 16.2-8.8 26.3-12.6 10-3.8 17.8-4.9 23.1-3.1 8.6 21.5 9.4 40.9 2.3 58.2a83.3 83.3 0 0122.6 58.8c0 16.2-2 30.5-5.9 43a88.4 88.4 0 01-15.1 30 79.8 79.8 0 01-23.1 19c-9.3 5-18.2 8.8-26.9 11-8.6 2.4-18.4 4-29.2 5.2 9.9 8.6 14.8 22.1 14.8 40.6v60.2c0 3.4 1.2 6.3 3.6 8.6 2.4 2.2 6.1 3 11.3 2 44.1-14.7 80.1-41.1 108-79.3a213.1 213.1 0 0041.8-128.9c0-39.7-9.8-76.4-29.4-110z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "GithubIcon",
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>

<style scoped></style>
